import { Attachment } from '@/checkout-instore-legacy/product/typings'
import React, { ReactNode, useState } from 'react'

import {
  AttachmentsContext,
  ItemWithAttachements,
  SetAttachmentsStateProps,
} from '../context/AttachmentsContext'

interface AttachmentsProviderProps {
  children: ReactNode
}

export const AttachmentsProvider = ({ children }: AttachmentsProviderProps) => {
  const [attachments, setAttachments] = useState<Attachment[]>()
  const [skuId, setSkuId] = useState<string>()
  const [manualPrice, setManualPrice] = useState<number | null>()
  const [quantity, setQuantity] = useState<number>()
  const [showAttachments, setShowAttachments] = useState<boolean>(false)
  const [customOnSubmit, setcustomOnSubmit] = useState<
    ((item: ItemWithAttachements) => void) | undefined
  >(undefined)

  const [beforeAddToCart, setBeforeAddToCart] = useState<
    (() => void) | undefined
  >(undefined)

  const setAttachmentState = ({
    attachments,
    skuId,
    manualPrice,
    quantity,
    customOnSubmit: customOnSubmit,
    beforeAddToCart,
  }: SetAttachmentsStateProps) => {
    setAttachments(attachments ? [...attachments] : [])
    setSkuId(skuId)
    setManualPrice(manualPrice)
    setQuantity(quantity)
    setShowAttachments(true)

    if (beforeAddToCart) {
      setBeforeAddToCart(() => beforeAddToCart)
    }

    if (customOnSubmit) {
      setcustomOnSubmit(() => customOnSubmit)
    }
  }

  return (
    <AttachmentsContext.Provider
      value={{
        attachments,
        skuId,
        manualPrice,
        quantity,
        showAttachments,
        setAttachmentState,
        setShowAttachments,
        customOnSubmit,
        beforeAddToCart,
      }}
    >
      {children}
    </AttachmentsContext.Provider>
  )
}
